<div class="wrapper">
  <div class="header">
    <h2>Счета</h2>
  </div>
  <div class="wrapperBody">
    <div class="loading-shade" *ngIf="loading">
      <mat-spinner *ngIf="loading"></mat-spinner>
    </div>
    <table mat-table [dataSource]="banks" matSort (matSortChange)="sortData($event)">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Наименование</th>
        <td mat-cell class="hoverToggle" *matCellDef="let bank">
          {{ bank.description }}
        </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>ID</th>
        <td mat-cell *matCellDef="let bank">
          {{ bank.id }}
        </td>
      </ng-container>
      <ng-container matColumnDef="balance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Баланс</th>
        <td mat-cell *matCellDef="let bank">
          {{ supportService.formatMoney(bank.balance) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="moneyType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Тип</th>
        <td mat-cell *matCellDef="let bank">
          {{ bank.moneyType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let bank">
          <div class="btnHolder">
            <button
              mat-icon-button
              color="primary"
              (click)="openWriteOffDialog(bank)"
              title="Списать деньги"
            >
              <mat-icon>remove_circle</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              (click)="openAddDialog(bank)"
              title="Добавить деньги"
            >
              <mat-icon>add_circle</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              (click)="openMoveDialog(bank)"
              title="Переместить деньги"
            >
              <mat-icon>trending_flat</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator #paginator [length]="resultsLength" [pageSize]="pageSize"></mat-paginator>
  </div>
</div>
